import styled from 'styled-components'

export const StyledInvitationWrapper = styled.div`
  flex: 1;
  width: 100%;

  .invitations-inner {
    width: 1100px;
    margin: 0 auto;
    padding: 30px 0;
  }
  .bread-thumb {
    padding-bottom: 30px;
    margin-bottom: 25px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    border-bottom: 0.5px solid rgba(44, 44, 77, 0.1);
    a {
      font-size: 15px;
      line-height: 22px;
      color: ${({ theme }) => theme.colors.textTertiary};
    }
    span {
      font-weight: 500;
      font-size: 15px;
      line-height: 22px;
      color: ${({ theme }) => theme.colors.textTitle};
    }
    img {
      margin: 0 20px;
    }
  }
  .card-wrap {
    background: white;
    border-radius: 12px;
    padding: 20px 40px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;

    .load-more {
      margin-top: 20px;
      font-size: 17px;
      line-height: 27px;
      color: ${({ theme }) => theme.colors.textTertiary};
      cursor: pointer;
    }
    .loading-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 40px 0;
      width: 100%;
    }
    table {
      width: 100%;
      thead {
        th {
          font-size: 13px;
          line-height: 20px;
          color: ${({ theme }) => theme.colors.textTertiary};
          font-weight: normal;
          cursor: pointer;
          text-align: right;
          div {
            display: inline-flex;
            align-items: center;
          }
        }
        th:first-child {
          cursor: default;
          text-align: left;
          display: flex;
          align-items: center;
        }
      }
      tbody {
        tr {
          border-bottom: 0.5px solid rgba(44, 44, 77, 0.1);
          height: 70px;
          td {
            font-size: 17px;
            text-align: right;
          }
          td:first-child {
            text-align: left;
          }
        }
      }
    }

    div {
      dt {
        font-size: 13px;
        line-height: 20px;
        color: ${({ theme }) => theme.colors.textTertiary};
      }
      dd {
        font-weight: bold;
        font-size: 15px;
        line-height: 22px;
        color: ${({ theme }) => theme.colors.primary};
        margin-top: 4px;

        &.address {
          color: #404040;
          font-weight: normal;
        }
      }
      &:last-child {
        text-align: right;
      }
    }
  }

  .placeholder {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    padding: 100px;

    p {
      font-size: 15px;
      line-height: 21px;
      color: ${({ theme }) => theme.colors.textTertiary};
      margin-top: 20px;
    }
  }
  @media screen and (max-width: 960px) {
    margin-top: 30px;

    .invitations-inner {
      width: 100%;
      padding: 0 15px;
    }
    .bread-thumb {
      padding: 20px 0;
      display: none;
    }
    .card-wrap {
      padding: 20px;

      table {
        tbody {
          tr {
            td {
              font-size: 15px;
            }
          }
        }
      }
    }
    .invitation-overview {
      flex-flow: row wrap;
      & > div {
        width: 50%;

        &:nth-child(2) {
          text-align: right;
        }
        &:last-child {
          text-align: left;
          width: 100%;
          border-top: 0.5px solid rgba(44, 44, 77, 0.1);
          padding-top: 10px;
        }
      }
    }
  }
`
